import Vue from 'vue'
import Router from 'vue-router'

import Map from './modals/Map'
import Providers from './modals/Providers'
import NoCoverage from './modals/NoCoverage'
import Packages from './modals/Packages'

Vue.use(Router);

export default new Router({
	mode: 'abstract', // no hashbang or url changes, does not allow for query params
	routes: [
		{ path: '/coverage', name: 'coverage', component: Map },
		{ path: '/providers', name: 'providers', component: Providers },
		{ path: '/no-coverage', name: 'no-coverage', component: NoCoverage },
		{ path: '/packages', name: 'packages', component: Packages },
	]
})
